import React, { useState } from "react";
import { useGlobalContext } from "../../GlobalContext";
import Mutasihariraya from "./pdf/Mutasihariraya"; // Import fungsi PDF

function MutasiHariRaya() {
  const { bulan, api } = useGlobalContext();
  const Tahunaktif = new Date().getFullYear();
  const tahunterakhir = Array.from({ length: 3 }, (_, i) => Tahunaktif - i);
  const [selectedBulan, setSelectedBulan] = useState(0);
  const [selectedYear, setSelectedYear] = useState(tahunterakhir[0]);
  const [loading, setLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const handleBulanChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value >= 0 && value < bulan.length) {
      setSelectedBulan(value);
    } else {
      console.error("Bulan tidak valid:", value);
    }
  };  

  const handleTahunChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const handleSubmit = async () => {
    let bulanNumber = (selectedBulan + 1).toString().padStart(2, "0");
    let periode = `${selectedYear}${bulanNumber}`;
    let namaBulan = bulan[selectedBulan] || "Tidak Diketahui";
    let tahun = selectedYear;
  
    setLoading(true);
  
    try {
      const response = await api.get(`/api/laporan/mutasihariraya/${periode}`);            
      const result = response.data.data;
      if (!result || result.length === 0) {
        alert(`Data tidak ditemukan untuk periode ${namaBulan} ${tahun}.`);        
      } else {
        Mutasihariraya(periode, result, namaBulan, tahun);
      }
    } catch (error) {
      console.error("Gagal mengambil data:", error);
      alert(`Terjadi kesalahan saat mengambil data: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleExportExcel = async () => {
    let bulanNumber = (selectedBulan + 1).toString().padStart(2, "0");
    let periode = `${selectedYear}${bulanNumber}`;
    let namaBulan = bulan[selectedBulan] || "Tidak Diketahui";
    let tahun = selectedYear;

    setIsExporting(true);
    try {
      const response = await api.get(`/api/exsportexcell/mutasihariraya/${periode}`, {
        responseType: 'blob',
      });

      const filename = `Mutasi_HariRaya_${namaBulan}_${tahun}.xlsx`;
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Export Excel error:', err);
      alert('Gagal mengekspor Excel.');
    } finally {
      setIsExporting(false);
    }
  };
  
  return (    
    <div>
      <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center" }}>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-info" style={{ width: "400px" }}>
              <div className="card-header">
                <h5 className="card-title">Laporan Mutasi Hari Raya</h5>
              </div>
              <div className="card-body">
              <form className="form-horizontal">
                
                  <div className="form-group row">    
                    <label htmlFor="bulan" className="col-sm-3 col-form-label">Periode</label>                                   
                      <div className="col-sm-6" style={{ flex: 1 }}>
                        <select 
                          className="form-control" 
                          name="bulan"
                          value={selectedBulan}
                          onChange={handleBulanChange}
                          >
                          {bulan.map((item, index) => (
                              <option key={index} value={index}>{item}</option>
                          ))}
                        </select>
                      </div>                      
                      <div className="col-sm-4" style={{ flex: 1 }}>
                      <select 
                        className="form-control" 
                        name="tahun"
                        value={selectedYear}
                        onChange={handleTahunChange}
                        >
                        {tahunterakhir.map((year) => (
                          <option key={year} value={year}>{year}</option>
                        ))}
                      </select>
                      </div>                    
                  </div>                                                  
              </form>  
              </div> 
              <div className="modal-footer">
                <button type="button" className="btn btn-sm btn-primary mr-2" onClick={handleSubmit} disabled={loading}>
                  {loading ? "Mengambil Data..." : "Cetak"}
                </button>
                <button type="button" className="btn btn-sm btn-success" onClick={handleExportExcel} disabled={isExporting}>
                  {isExporting ? "Mengekspor..." : "Export Excel"}
                </button>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </div>
  )
}

export default MutasiHariRaya
